import { useContext, useEffect, useState } from "react";
import axios from 'axios';
import { APIURL, STORAGEURL } from "..";
import { Link, useNavigate } from "react-router-dom"; 
import { AppContext, LinkButton } from './Layout'; 
import parse from 'html-react-parser'

import sqrhi from "../assets/svg/sqrhi.svg";
import sqrlo from "../assets/svg/sqrlo.svg";
import star from '../assets/svg/star.svg'

import hp_pic from "../assets/hp_pic.png";
import karty from '../assets/karty.png';
import karty_grid from '../assets/karty_grid.png'

import ReactPlayer from "react-player";
import Loading from "../components/UI/Loading";
import FeedbackSwiper from "../components/FeedbackSwiper";
import Formular from "../components/Formular";

const Karty = () => { 
  const { language, pages, setPages } = useContext(AppContext)||{};
  const data = pages.cards;
  const navigate = useNavigate(); 

  const getPageData = async () => {  
    await axios.post(APIURL+'/page', {name: 'cards', language: language}).then(async response =>{
      setPages((prev)=>({ ...prev, cards:response.data.body}));
    }).catch(()=>{
      navigate('/')
    })
  } 

  useEffect(() => {
    if (!pages?.cards) {
      getPageData();
    }
  }, [pages]);

  if (!data) {return <Loading />} else 
  return (<>
    <main className="flex flex-col items-center maxSection">
      <div className="w-full flex flex-col items-center text-center py-14">
        <div className="w-full flex mobil:flex-col gap-y-8 justify-between z-10">
          <div className="min-w-[30%] text-left mobil:text-center">
            <h1>{data.intro_header}</h1>
            <p className="text-purplee-400 pb-7 font-semibold">{data.intro_text}</p>
            <LinkButton to="#form" type='karty' className="mobil:!w-full" />
          </div>
          <div className="-mb-[8%] tablet:mb-0 mobil:-mb-[15%]">
            <img src={hp_pic} className="w-full max-w-full" />
          </div>
        </div>

        <div className="-mt-14 tablet:mt-4 w-full bg-purplee-500 text-white flex mobil:flex-col items-center p-7 rounded-xl gap-4 text-left">
          <h2 className="basis-1/3">{data.subintro_title}</h2>
          <div className="basis-2/3">
            <div>{parse(data.subintro_text||'')}</div>
          </div>
        </div>
      </div>
      <div className="nemobil:w-2/3 m-auto text-center py-4 pt-14">
        <h2>{data.ideamaking_title}</h2>
        <p className="text-purplee-400">{data.ideamaking_text}</p>
      </div>
      <div className="my-4 mb-14">
        <img src={STORAGEURL+data.ideamaking_img} />
      </div>
      {data.contains_cards?.[0]&&<div className="hpSection items-center">
        <div>
          <h2>{data.contains_title}</h2>
          <div className="box_ul pb-4">{parse(data.contains_cards[0].list)||""}</div>
          <strong className="text-3xl py-4 border-t border-azur-100 block">{data.contains_cards[0].price} Kč <sub className="font-light text-lg">vč. DPH</sub></strong>
          <LinkButton to="#form" type='karty' />
          <p className="!text-purplee-400 my-4">{parse(data.contains_cards[0].comment||'')}</p>
        </div>
        <div> 
          <img src={karty_grid} alt="Karty" className="w-full aspect-square object-contain" />
          <img src={karty} alt="Karty" className="absolute right-0 top-1/2 -translate-y-1/2 w-[130%] max-w-none object-contain" />
          <div className="absolute left-1/2 bottom-1/2 glassbox">
            <img src={star} />
            <p>Garance nápadu<br/>zaručena!</p>
          </div>
        </div>
      </div>}
      <div className="my-4 w-full text-center flex flex-col items-center gap-4 [&_div]:!w-full [&_div]:!h-full [&_div]:aspect-video">
        <h2 className="max-w-sm">{data.how_title}</h2>
        <ReactPlayer url={data.how_video_url} controls />
        <a className="button light" href={STORAGEURL+data.how_materials} target='_blank' >Materiály ke stažení</a>
      </div>
    </main>
    {data.reviews_items?.length&&<div className="my-14 w-full text-center">
      <h2>{data.reviews_title}</h2>
      <FeedbackSwiper items={data.reviews_items} />
    </div>}
    <main className="flex flex-col items-center maxSection !min-h-0">
      <div className="hpSection !pb-14">
        <div>
          <img src={STORAGEURL+data.workshop_img} className=" rounded-xl w-full h-auto" />
          <img src={sqrhi} className="absolute w-[30%] -left-4 -top-4" />
          <img src={sqrlo} className="absolute w-[56%] -bottom-4 -right-4" />
        </div>
        <div>
          <h2>{data.workshop_title}</h2>
          <span>{data.workshop_text}</span>
          <LinkButton type="workshop" />
        </div>
      </div>
      <Formular name="cards" title={data.form_title} text={data.form_text} />
    </main>
  </>);
}

export default Karty;
